import { TsDOM as q} from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { EmblaSlider } from '@/scripts/theme/embla-slider'
import { RecentlyViewedManager } from '@/scripts/theme/recently-viewed-manager'
import { CardColorSwatches } from '@/scripts/theme/card-color-swatches'
import { InstagramFeed } from '@/scripts/theme/instagram-feed'
import { SearchDrawer } from '@/scripts/theme/search-drawer'
import { PsTimer } from '@/scripts/theme/ps-timer'
import { MulticolumnIcon } from '@/scripts/theme/multicolumn-icon'
import { FinePrintPopup } from '@/scripts/theme/fine-print-popup'
import { Lookbook } from '@/scripts/theme/lookbook'
import { LEDBanner } from '@/scripts/theme/led-banner'
q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(EmblaSlider)
q.safeDefineElement(RecentlyViewedManager)
q.safeDefineElement(CardColorSwatches)
q.safeDefineElement(InstagramFeed)
q.safeDefineElement(SearchDrawer)
q.safeDefineElement(PsTimer)
q.safeDefineElement(MulticolumnIcon)
q.safeDefineElement(FinePrintPopup)
q.safeDefineElement(Lookbook)
q.safeDefineElement(LEDBanner)